module.exports = __webpack_public_path__ + "static/media/info-circle.130b51ec.svg";